import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class SrFollowUpService {
    constructor(private readonly datatask: DataTaskService) {}
    /** @datatask 2130 */
    public async getFollowUp(params: SrFollowUpParams): Promise<SrFollowUpGet> { return (await this.datatask.Post(2130, params))[0]; }
    /** @datatask 2131 */
    public getResponsibleLabours(params: { special_resource_id_to: string }): Promise<Item[]> { return this.datatask.Post(2131, params); }
    /** @datatask 2132 */
    public getComments(params: SrFollowUpParams): Promise<SrFollowUpComment[]> { return this.datatask.Post(2132, params); }
    /** @datatask 2134 */
    public async addResponsibleLabour(params: SrFollowUpParams & { responsible_labour_no: string }): Promise<ErrorMessageResponse> { return (await this.datatask.Post(2134, params))[0]; }
    /** @datatask 2133 */
    public async addComment(params: SrFollowUpCommentParams): Promise<ErrorMessageResponse> { return (await this.datatask.Post(2133, params))[0]; }
    /** @datatask 2135 */
    public async getForward(params: SrFollowUpParams): Promise<SrFollowUpForwardGet> { return (await this.datatask.Post(2135, params))[0]; }
    /** @datatask 2136 */
    public getForwardResources(params: SrFollowUpParams): Promise<Item[]> { return this.datatask.Post(2136, params); }
    /** @datatask 2137 */
    public async sendForward(page: SrFollowUpForwardGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(2137, page))[0]; }
    /** @datatask 2128 */
    public async getFollowUps(): Promise<SrFollowUpsGet> { return (await this.datatask.Post(2128, {}))[0]; }
    /** @datatask 2129 */
    public getFollowUpList(page: SrFollowUpsGet): Promise<Item[]> { return this.datatask.Post(2129, page); }
}

export interface SrFollowUpParams { experience_keyno: string; }
export interface SrFollowUpGet extends SrFollowUpParams {
    custact_no: string;
    special_hrsno: string;
    from_sr_labour_name: string;
    experience_description: string;
    special_resource_id_to: string;
    special_resource_name_to: string;
    responsible_labour_no: string;
    responsible_labour_name: string;
    special_devstatus_name: string;
    comment_heading: string;
    new_note: string;
    show_forward_to_new_resource: string;
    show_change_responsible_labour_no: string;
    show_new_note: string;
    show_new_note_and_add: string;
    show_new_note_and_close: string;
    show_reopen: string;
}
export interface SrFollowUpComment { labour_name: string; reg_date: string; note: string; mymessage: string; }
export interface SrFollowUpCommentParams extends SrFollowUpParams { new_note: string; func: 'ADD' | 'CLOSE' | 'REOPEN'; }
export interface SrFollowUpForwardGet extends SrFollowUpParams {
    w_srfollowupforward_info: string;
    special_hrsno: string;
    note: string;
    special_resource_id_to_new: string;
}
export interface SrFollowUpsGet {
    gb_srfollowups_main: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: string;
    date_fomtom: string;
    filterval: string;
    show_sub_resources: string;
}
